import gql from 'graphql-tag'

export default gql `
  query getAppointment(
    $id: ID!
    $token: String!
  ) {
    appointment: getAppointment(
      id: $id
      token: $token
    ) {
      id
      business
      service
      staff
      customer
      date
      clientTimezone
      reviews
      answers
    }
    business: businessByAppointment(
      appointmentId: $id
    ){
      id
      availableFeatures
      bookingTemplatesHtml
    }
  }
`
